import { action, computed, observable, store } from '~/common/mobx.decorator'
import { FAVORIE_UNFAVORITE_JOBS_MUTATION, apolloClient } from '~/common/apollo'
import { GET_LIST_BOOK_MARK } from '~/common/apollo/mutations/jobs-filter.mutation'

const LIMIT_PAGE = 24

export const ACTIONS = {
	favorite: 'favorite',
	unfavorite: 'unfavorite',
}
@store()
class BookmarkStore {
	@observable bookMarkJobs = []
	@observable bookMarkInfo
	@observable totalBookMarkCount = 0
	@observable selectedBookMarkJob = null

	@computed
	get hasNextPage() {
		return this.bookMarkInfo?.hasNextPage || false
	}

	@computed
	get endCursor() {
		return this.bookMarkInfo?.endCursor
	}

	@computed
	get bookMarkJobsItems() {
		return this.bookMarkJobs
	}

	@action
	fetchBookMarkedJobs = async () => {
		const response = await apolloClient.query({
			query: GET_LIST_BOOK_MARK,
			variables: { first: LIMIT_PAGE },
		})

		this.bookMarkJobs = response?.data?.favoritedJobs?.nodes
		this.bookMarkInfo = response?.data?.favoritedJobs?.pageInfo
		this.totalBookMarkCount = response?.data?.favoritedJobs?.totalCount
	}

	@action
	onScrollToEnd = async () => {
		const response = await apolloClient.query({
			query: GET_LIST_BOOK_MARK,
			variables: { first: LIMIT_PAGE, after: this.endCursor },
		})
		this.bookMarkInfo = response.data.favoritedJobs.pageInfo
		this.bookMarkJobs = [...this.bookMarkJobs, ...response.data.favoritedJobs.nodes]
		this.totalBookMarkCount = this.bookMarkJobs.length
	}

	@action
	likeJob = async (jobId, isFavorite) => {
		const response = await apolloClient.query({
			query: FAVORIE_UNFAVORITE_JOBS_MUTATION,
			variables: {
				jobId: jobId,
				action: isFavorite ? ACTIONS.unfavorite : ACTIONS.favorite,
			},
		})
		this.selectedBookMarkJob = response?.data?.favoriteOrUnfavoriteJob
		await this.fetchBookMarkedJobs()
		return response?.data?.favoriteOrUnfavoriteJob
	}
}

export const bookMarkStore = new BookmarkStore()
